<template>
  <div role="alert" :class="'el-message el-message--' + type" v-if="visible" style="top: 20px; z-index: 3000;" @mouseenter="enter" @mouseleave="leave">
    <i :class="'el-message__icon el-icon-'+type"></i>
    <div class="el-message__content">{{content}}
      <i v-if="hasClose" class="el-message__closeBtn el-icon-close" @click="visible=false"></i>
    </div>
  </div>

</template>

<script>
export default {
  name: "MyMessage",
  data() {
    return {
      content: '',
      time: 3000,
      visible: false,
      type: 'error',//'success','warning','error'
      hasClose: false,
      timeOunt: null
    }
  },
  mounted() {
    this.close()
  },
  methods: {
    enter() {
      window.clearTimeout(this.timeOunt)
    },
    leave() {
      this.close()
    },
    close() {
      this.timeOunt = setTimeout(() => {
        this.visible = false
      }, this.time);
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
